import { Component } from '@angular/core';
import { HttpErrorResponse } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthService, Credentials, UserModel, UserService } from "@bt/core";
import { TokenError } from "./login.interfaces";
import { Validators, EmailValidator, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { from } from 'rxjs/observable/from';
import { NotifierService } from 'angular-notifier';
import {faCheckCircle,faTimesCircle} from "@fortawesome/free-solid-svg-icons"
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { BaseComponent } from "@bt/core/base";
import * as $ from 'jquery';

library.add(fas, far);
library.add(faCheckCircle);
library.add(faTimesCircle);

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent extends BaseComponent {
  private notifier: NotifierService;
  public error: TokenError;
  public showLoader: boolean = false;
  textError: string;



  // private emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  public loginForm: FormGroup;
  public isSubmitted: boolean = false;
  public emailModel : any;
  public passwordModel : any;

  constructor(private authService: AuthService,
     private router: Router,
     private route: ActivatedRoute,
     private fb: FormBuilder,
     notifierService: NotifierService,
     private userService: UserService) {
    super();
    this.textError = "";
    this.notifier = notifierService;

    var t=this;

  }

  public login() {
    var t = this;
    this.isSubmitted = true;

    if (!this.loginForm.valid){
      this.textError = "Проверьте корректность введённых данных";
      var alert = document.getElementsByClassName("myalert");
      (<any>alert[0]).style.display = "block";
      setTimeout(function () { (<any>alert[0]).style.display = "none"; }, 4000)
      this.showLoader = false;
      return;
    }


    const credentials: Credentials = this.loginForm.value;
    if (!this.showLoader) {
      this.showLoader = true;
      t.setLoading(true);
      this.authService
        .login(credentials)
        .subscribe(
          (response) => {
            this.userService
              .getUser()
              .then(
                (response) => {

                  if (response.data.role == 1 || response.data.role == 0) {
                    this.router.navigateByUrl("app/push-notification")
                      .then(() => this.showLoader = false);
                  }
                  else if (response.data.role == 2) {
                    this.router.navigateByUrl("app/push-notification")
                      .then(() => this.showLoader = false);
                  }
                  t.setLoading(false);

                },
              )
              .catch((error) => {
                console.error(error.error);
                this.authService.logout();
                t.setLoading(false);

              });

          },
          (error: HttpErrorResponse) => {
            t.error = error.error;
            if (t.error != undefined && t.error.error_description != undefined) {

              t.textError = t.error.error_description;
              if (t.textError == "Invalid username or password")
                t.textError = "Неправильный логин или пароль";
              var alert = document.getElementsByClassName("myalert");
              (<any>alert[0]).style.display = "block";
              setTimeout(function () { (<any>alert[0]).style.display = "none"; }, 4000)
            }

            console.log("Error:" + t.error.error_description);
            this.showLoader = false;
            t.setLoading(false);

          }
        );
    }
  }

  public clearError() {
    this.error = null;
  }

  public ngOnInit() {
    this.loginForm = this.fb.group({
      email: ["", [Validators.required]],//Validators.pattern(this.emailPattern)
      password: new FormControl(null, Validators.required),
    });

    this.loginForm.valueChanges
      .filter(() => !!this.error)
      .forEach(() => {
        this.clearError();
      });

    if(window.location.href.indexOf('?ref=') != -1){
      localStorage.setItem("refLink", window.location.href.substring(window.location.href.indexOf('?ref=') + 5));
    } 
    else localStorage.setItem("refLink", 'A');

  }

  // public alwaysChecked(){
  //   this.checkbox.setValue(true);
  // }
  get email() { return this.loginForm.get('email'); }
  get password() { return this.loginForm.get('password'); }


}



// WEBPACK FOOTER //
// ./src/app/public/login/login.component.ts